import React, { FC, PropsWithChildren } from 'react';
import { Breakpoint } from 'antd/es/_util/responsiveObserver';
import { useScreenSize } from '../useScreenSize';
import styled from 'styled-components';
import { useGlobalTokenValue } from '../useGlobalTokenValue';

export type BleedSize = Breakpoint | 'responsive';

export interface BleedProps extends PropsWithChildren {
  size?: BleedSize;
  direction?: 'vertical' | 'horizontal' | 'both';
}

export const Bleed: FC<PropsWithChildren<BleedProps>> = (props) => {
  const { direction = 'both' } = props;
  const screenSize = useScreenSize();
  const size =
    props.size && props.size !== 'responsive' ? props.size : screenSize || 'ms';
  const tokenKey = `size${
    size.toUpperCase() as Uppercase<Breakpoint>
  }` as const;
  const bleedSize = useGlobalTokenValue(tokenKey);

  return (
    <BleedDiv
      $bleedSize={bleedSize}
      $dimension={directionDimensionMap[direction]}
    >
      {props.children}
    </BleedDiv>
  );
};

const BleedDiv = styled.div<{
  $bleedSize: number;
  $dimension?: 'inline' | 'block';
}>`
  margin${(p) => (p.$dimension ? `-${p.$dimension}` : '')}: -${(p) =>
  p.$bleedSize}px;
`;

const directionDimensionMap = {
  horizontal: 'inline' as const,
  vertical: 'block' as const,
  both: undefined,
};
